<div class="session-card cdfi-profile-card" id="tour-cdfi-profile-card">
  <div class="section-header cdfi-header">
    <div
      class="avatar-wrapper"
      (appClickOutside)="closeCdfiLogoDropdown()"
      id="tour-cdfi-logo"
    >
      <div class="profile-avatar" [class.no-image]="!cdfiLogoSrc">
        @if (cdfiLogoSrc) {
          <img [src]="cdfiLogoSrc" [alt]="connectionName" class="profile-img" />
        } @else {
          <span class="userName">{{ connectionName?.charAt(0) }}</span>
        }
      </div>

      <button
        class="avatar-edit-button"
        (click)="onCdfiLogoIconClick(logoInput)"
        (keyup.enter)="onCdfiLogoIconClick(logoInput)"
        tabindex="0"
        aria-label="Change CDFI logo"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25ZM20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C17.98 2.9 17.35 2.9 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04Z"
            fill="currentColor"
          />
        </svg>
      </button>

      @if (isCdfiLogoDropdownOpen) {
        <div class="profile-dropdown">
          <ul>
            <li
              (click)="logoInput.click()"
              (keyup.enter)="logoInput.click()"
              tabindex="0"
              role="button"
            >
              {{ cdfiLogoSrc ? "Change logo" : "Upload logo" }}
              <span class="icon">
                <svg
                  width="15"
                  height="15"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 640"
                >
                  <path
                    d="M160 144C151.2 144 144 151.2 144 160L144 480C144 488.8 151.2 496 160 496L480 496C488.8 496 496 488.8 496 480L496 160C496 151.2 488.8 144 480 144L160 144zM96 160C96 124.7 124.7 96 160 96L480 96C515.3 96 544 124.7 544 160L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 160zM224 192C241.7 192 256 206.3 256 224C256 241.7 241.7 256 224 256C206.3 256 192 241.7 192 224C192 206.3 206.3 192 224 192zM360 264C368.5 264 376.4 268.5 380.7 275.8L460.7 411.8C465.1 419.2 465.1 428.4 460.8 435.9C456.5 443.4 448.6 448 440 448L200 448C191.1 448 182.8 443 178.7 435.1C174.6 427.2 175.2 417.6 180.3 410.3L236.3 330.3C240.8 323.9 248.1 320.1 256 320.1C263.9 320.1 271.2 323.9 275.7 330.3L292.9 354.9L339.4 275.9C343.7 268.6 351.6 264.1 360.1 264.1z"
                  />
                </svg>
              </span>
            </li>
            @if (cdfiLogoSrc) {
              <li
                (click)="deleteCdfiLogo()"
                (keyup.enter)="deleteCdfiLogo()"
                class="danger"
                tabindex="0"
                role="button"
              >
                Remove
                <span class="icon">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 6H21"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M19 6V20C19 21 18 22 17 22H7C6 22 5 21 5 20V6"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8 6V4C8 3 9 2 10 2H14C15 2 16 3 16 4V6"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </li>
            }
          </ul>
        </div>
      }

      <input
        #logoInput
        type="file"
        accept=".jpg, .jpeg, .png, .heic, .heif"
        (change)="onCdfiLogoSelected($event)"
        hidden
      />
    </div>

    <div class="cdfi-header-text">
      <h2>{{ cdfiForm.name }}</h2>
      <p class="section-description">
        Manage the public-facing details for your organization.
      </p>
    </div>
    @if (!isEditMode) {
      <div class="header-actions">
        <button
          type="button"
          class="edit-btn"
          (click)="toggleEditMode()"
          id="tour-cdfi-edit-btn"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="12"
            width="12"
            viewBox="0 0 640 640"
          >
            <path
              d="M416.9 85.2L372 130.1L509.9 268L554.8 223.1C568.4 209.6 576 191.2 576 172C576 152.8 568.4 134.4 554.8 120.9L519.1 85.2C505.6 71.6 487.2 64 468 64C448.8 64 430.4 71.6 416.9 85.2zM338.1 164L122.9 379.1C112.2 389.8 104.4 403.2 100.3 417.8L64.9 545.6C62.6 553.9 64.9 562.9 71.1 569C77.3 575.1 86.2 577.5 94.5 575.2L222.3 539.7C236.9 535.6 250.2 527.9 261 517.1L476 301.9L338.1 164z"
            />
          </svg>
          Edit
        </button>
      </div>
    }
  </div>

  @if (cdfiProfileLoading) {
    <div class="skeleton-group">
      <div class="skeleton skeleton-input w-full"></div>
      <div class="skeleton skeleton-input w-full"></div>
      <div class="skeleton skeleton-textarea w-full"></div>
    </div>
  } @else if (cdfiProfile) {
    <form class="cdfi-profile-form" (ngSubmit)="saveCdfiProfile()">
      <div class="form-field" id="tour-cdfi-name-field">
        <label for="cdfi-name">Name</label>
        @if (isEditMode) {
          <input
            id="cdfi-name"
            type="text"
            [(ngModel)]="cdfiForm.name"
            name="cdfi-name"
            #nameModel="ngModel"
            required
            [class.invalid]="
              (nameModel.invalid || !cdfiForm.name.trim()) &&
              (nameModel.dirty || nameModel.touched)
            "
          />
          @if (
            (nameModel.invalid || !cdfiForm.name.trim()) &&
            (nameModel.dirty || nameModel.touched)
          ) {
            <div class="error-message">Name is required.</div>
          }
        } @else {
          <div class="readonly-value">{{ cdfiForm.name }}</div>
        }
      </div>

      <div class="form-field" id="tour-cdfi-email-field">
        <label for="cdfi-email">Email</label>
        @if (isEditMode) {
          <input
            id="cdfi-email"
            type="email"
            [(ngModel)]="cdfiForm.email"
            name="cdfi-email"
            #emailModel="ngModel"
            [pattern]="EMAIL_REGEX"
            [class.invalid]="
              emailModel.invalid && (emailModel.dirty || emailModel.touched)
            "
          />
          @if (emailModel.invalid && (emailModel.dirty || emailModel.touched)) {
            <div class="error-message">Please enter a valid email address.</div>
          }
        } @else {
          <div class="readonly-value">{{ cdfiForm.email || "-" }}</div>
        }
      </div>

      <div class="form-field" id="tour-cdfi-phone-field">
        <label for="cdfi-phone">Phone</label>
        @if (isEditMode) {
          <input
            id="cdfi-phone"
            type="text"
            [(ngModel)]="cdfiForm.phone"
            name="cdfi-phone"
            #phoneModel="ngModel"
            [pattern]="PHONE_REGEX"
            maxlength="20"
            [class.invalid]="
              phoneModel.invalid && (phoneModel.dirty || phoneModel.touched)
            "
          />
          @if (phoneModel.invalid && (phoneModel.dirty || phoneModel.touched)) {
            <div class="error-message">Please enter a valid phone number.</div>
          }
        } @else {
          <div class="readonly-value">{{ cdfiForm.phone || "-" }}</div>
        }
      </div>

      <div class="form-field" id="tour-cdfi-website-field">
        <label for="cdfi-website">Website</label>
        @if (isEditMode) {
          <input
            id="cdfi-website"
            type="url"
            [(ngModel)]="cdfiForm.website"
            name="cdfi-website"
            #websiteModel="ngModel"
            [pattern]="WEBSITE_REGEX"
            maxlength="500"
            [class.invalid]="
              websiteModel.invalid &&
              (websiteModel.dirty || websiteModel.touched)
            "
          />
          @if (
            websiteModel.invalid && (websiteModel.dirty || websiteModel.touched)
          ) {
            <div class="error-message">Please enter a valid website URL.</div>
          }
        } @else {
          <div class="readonly-value">
            @if (cdfiForm.website) {
              <a [href]="getWebsiteUrl(cdfiForm.website)" target="_blank">{{
                cdfiForm.website
              }}</a>
            } @else {
              -
            }
          </div>
        }
      </div>

      <div class="form-field full-width" id="tour-cdfi-description-field">
        <label for="cdfi-description">Description</label>
        @if (isEditMode) {
          <textarea
            id="cdfi-description"
            [(ngModel)]="cdfiForm.description"
            name="cdfi-description"
            #descriptionModel="ngModel"
            rows="6"
            [class.invalid]="
              cdfiForm.description &&
              cdfiForm.description.trim().length === 0 &&
              cdfiForm.description.length > 0 &&
              (descriptionModel.dirty || descriptionModel.touched)
            "
          ></textarea>
          @if (
            cdfiForm.description &&
            cdfiForm.description.trim().length === 0 &&
            cdfiForm.description.length > 0 &&
            (descriptionModel.dirty || descriptionModel.touched)
          ) {
            <div class="error-message">Description cannot be only spaces.</div>
          }
        } @else {
          <div class="readonly-value description-text">
            <span
              #descriptionText
              [class.description-clamped]="!isDescriptionExpanded"
              >{{ cdfiForm.description || "-" }}</span
            >
            @if (isDescriptionOverflowing || isDescriptionExpanded) {
              <button
                type="button"
                class="see-more-btn"
                (click)="toggleDescription()"
              >
                {{ isDescriptionExpanded ? "See less" : "See more" }}
              </button>
            }
          </div>
        }
      </div>

      @if (isEditMode) {
        <div class="info-message warning full-width">
          <span class="icon">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 9V11M12 15H12.01M5.07183 19H18.9282C20.4678 19 21.4301 17.3333 20.6603 16L13.7321 4C12.9623 2.66667 11.0378 2.66667 10.268 4L3.33978 16C2.56998 17.3333 3.53223 19 5.07183 19Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <div class="text">
            Information and logos shared within the Public Profile is used to
            provide public-facing information about your organization. This
            information may be featured in ACC Data Hub Network materials, such
            as public websites highlighting organizations that support
            businesses and entrepreneurs, and may also be used to share relevant
            details with businesses and entrepreneurs through the DeepRoots
            platform. All information uploaded must meet Data Hub
            <a href="/terms-of-use" target="_blank" style="color: #7c2ac8"
              >Terms and Use</a
            >.
          </div>
        </div>

        <div class="cdfi-actions">
          <button
            type="button"
            class="secondary-btn"
            (click)="toggleEditMode()"
            [disabled]="cdfiProfileSaving"
          >
            Cancel
          </button>

          <button
            type="submit"
            class="resume-btn"
            [disabled]="
              !isCdfiFormValid || !isCdfiFormChanged || cdfiProfileSaving
            "
          >
            {{ cdfiProfileSaving ? "Saving..." : "Save" }}
          </button>
        </div>
      }
    </form>
  }

  @if (historyItems.length > 0 || isHistoryLoading || historyError) {
    <div class="change-history-section" [class.expanded]="isHistoryExpanded">
      <button
        type="button"
        class="history-toggle-header"
        (click)="toggleHistory()"
        id="tour-history-toggle"
      >
        <h3 class="section-title">Change History</h3>
        <span class="expand-toggle-btn">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            [class.rotated]="isHistoryExpanded"
          >
            <path
              d="M7 10L12 15L17 10"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
      </button>

      @if (isHistoryExpanded) {
        <div class="timeline">
          @if (isHistoryLoading) {
            <div class="skeleton-group">
              <div class="skeleton skeleton-text w-full"></div>
              <div class="skeleton skeleton-text w-full"></div>
            </div>
          } @else if (historyError) {
            <div
              class="error-message p-3 text-center"
              style="color: var(--danger, red)"
            >
              {{ historyError }}
            </div>
          } @else {
            @for (
              item of historyItems;
              track $index;
              let first = $first;
              let last = $last
            ) {
              @if (!last || !hasMoreHistory) {
                <div class="timeline-item" [class.latest]="first">
                  <div class="timeline-marker"></div>

                  <div class="timeline-content">
                    <div class="history-header">
                      <div class="header-info">
                        <div class="user-summary">
                          @if (item.fieldListSummary) {
                            <span class="user-name">{{
                              item.changed_by_name
                            }}</span>
                            <span class="action-text"> updated </span>
                            <span class="fields-list">{{
                              item.fieldListSummary | titlecase
                            }}</span>
                          } @else {
                            <span class="fallback-summary">{{
                              item.summary
                            }}</span>
                          }
                        </div>
                        <span class="timestamp">
                          {{ item.updated_on_utc | date: "MMM d, y, h:mm a" }}
                        </span>
                      </div>

                      <div class="header-actions-links">
                        @if (first) {
                          <span class="current-badge">Current</span>
                        }
                      </div>
                    </div>

                    <div class="history-changes-list">
                      @for (change of item.changes; track change.label) {
                        <div class="change-entry">
                          <span class="field-label">{{ change.label }}</span>

                          <div class="change-values">
                            @if (change.oldValue) {
                              <span
                                class="old-value"
                                [class.is-none]="change.oldValue === 'None'"
                                >{{ change.oldValue }}</span
                              >

                              <span class="change-arrow">
                                <svg
                                  width="12"
                                  height="12"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M5 12H19M19 12L12 5M19 12L12 19"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </span>
                            }

                            <span
                              class="new-value"
                              [class.is-none]="change.newValue === 'None'"
                              >{{ change.newValue }}</span
                            >
                          </div>
                        </div>
                      } @empty {
                        <div class="no-changes">
                          No field changes in this version.
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            }

            @if (hasMoreHistory) {
              <div class="load-more-wrapper">
                <button
                  type="button"
                  class="load-more-btn"
                  (click)="loadMoreHistory()"
                  [disabled]="isLoadingMore"
                >
                  {{ isLoadingMore ? "Loading..." : "Load More" }}
                </button>
              </div>
            }
          }
        </div>
      }
    </div>
  }
</div>

@if (showDeleteCdfiLogoPopup) {
  <app-popup
    [heading]="'Delete CDFI Logo'"
    [confirmText]="'Delete'"
    [cancelText]="'Cancel'"
    (confirmClicked)="onConfirmDeleteCdfiLogo()"
    (cancelClicked)="onCancelDeleteCdfiLogo()"
  >
    <div class="popup-message">
      <p>Are you sure you want to delete the CDFI logo?</p>
    </div>
  </app-popup>
}
